<template>
  <a-modal
    :title="obj ? '编辑行业' : '新增行业'"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="industryForm"
      :model="industryForm"
      :rules="industryFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="行业名称" prop="name">
        <a-input v-model="industryForm.name" placeholder="请填写行业名称" />
      </a-form-model-item>

      <a-form-model-item label="核验通过语音" prop="deviceConfig.passVoice">
        <a-input v-model="industryForm.deviceConfig.passVoice" placeholder="请填写核验成功语音提示词" />
      </a-form-model-item>
      <a-form-model-item label="核验失败语音" prop="deviceConfig.notPassVoice">
        <a-input v-model="industryForm.deviceConfig.notPassVoice" placeholder="请填写核验失败语音提示词" />
      </a-form-model-item>

      <a-form-model-item label="设备应用签名" prop="deviceAppSign">
        <a-input v-model="industryForm.deviceAppSign" placeholder="请填写设备应用签名" />
      </a-form-model-item>

      <a-form-model-item label="状态" prop="state">
        <a-radio-group v-model="industryForm.state" :default-value="0">
          <a-radio :value="0">正常</a-radio>
          <a-radio :value="1">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="是否人证核验" prop="deviceConfig.enableIdValid">
        <a-radio-group v-model="industryForm.deviceConfig.enableIdValid" :default-value="1">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="首页图片" prop="sn">
        <a-upload
          name="avatar"
          list-type="picture-card"
          accept="image/png,image/jpg,image/gif"
          class="avatar-uploader"
          :show-upload-list="false"
          :beforeUpload="handleBeforeUploadImg"
        >
          <img v-if="industryForm.deviceConfig.homepagePhotoUrl" :src="industryForm.deviceConfig.homepagePhotoUrl" alt="avatar" />
          <div v-else>
            <a-icon :type="uploading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { compressImageFile } from '@/utils/utils'
import { FileUploadBase64 } from '@/apis/upload'
import { QueryTemplateList } from '@/apis/authResourceTemplate'


const industryForm = {
  id: undefined,
  name: undefined,
  state: 0,
  deviceAppSign: undefined,
  deviceConfig: {
    enableIdValid: undefined,
    homepagePhotoUrl: undefined,
    notPassVoice: undefined,
    passVoice: undefined
  },
}
const industryFormRules = {
  name: [{ required: true, message: '请填写行业名称！' }],
  state: [{ required: true, message: '请选择！' }]
}


export default {
  name: 'EditModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      industryForm,
      industryFormRules,
      templateList:[],
      uploading: false,
      confirmLoading:false
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          let { id, name, state,  deviceAppSign,  deviceConfig} = this.obj
          console.log(this.obj)
          if (!deviceConfig){
            deviceConfig = {
              enableIdValid: undefined,
              homepagePhotoUrl: undefined,
              notPassVoice: undefined,
              passVoice: undefined
            }
          }
          this.industryForm = { id, name, state,  deviceAppSign, deviceConfig }
        })
      }
    }
  },
  created() {
    // this.handleGetTemplateList()
  },
  methods: {
    handleGetTemplateList(){
      let _this = this
      QueryTemplateList({page: 1, perPage: 100}).then(res=>{
        _this.templateList = res.collection
      })
    },
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.industryForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.industryForm)
          this.confirmLoading = true
        }
      })
    },
    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.industryForm.resetFields()
      this.industryForm = industryForm
      this.confirmLoading = false
    },
    handleBeforeUploadImg(file){
      let options = file.type === 'image/gif' ? { maxSize: null } : { maxSize: 1024 }
      compressImageFile(file, options, this.handleUploadImg)
      return Promise.reject()
    },
    // 上传 Banner 图片
    async handleUploadImg(image) {
      try {
        this.uploading = true
        const base64NoHeader = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const res = await FileUploadBase64({
          dataBase64: base64NoHeader
        })
        this.uploading = false
        this.$message.success(`图片上传成功`)
        this.industryForm.deviceConfig.homepagePhotoUrl = res.data
      } catch (error) {
        this.$message.error(error)
        this.uploading = false
      }
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
